import React from 'react';
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { BiSolidMap } from "react-icons/bi"; 
import './Header.css';

const Header = () => {
  return (
    <div className="top-bar">
      <div className="container d-flex justify-content-between flex-wrap">
        <div className="left-info d-flex gap-4">
          <div className="info-item d-flex align-items-center">
            <FaPhoneAlt className="icon" />
            <a 
  href="tel:+919211460800" 
  style={{ textDecoration: "none", color: "inherit" }}
> 
  <span>+91 9211460800</span>
</a>
          </div>
         <div className="info-item d-flex align-items-center">
  <IoMdMail className="icon" />
  <a
    href="mailto:info@dhanwalle.com"
    style={{ textDecoration: "none", color: "inherit", marginLeft: "8px", fontSize: "16px", fontWeight: "700" }}
  >
    info@dhanwalle.com
  </a>
</div>

        </div>

        <div className="right-info info-item d-flex align-items-center">
  <BiSolidMap className="icon" />
  <span> VO-656 AT We Work Berger One, Sector16B, C-001/A2, Gautam Buddha Nagar, Noida</span>
</div>


      </div>
    </div>
  );
};

export default Header;
